
import Select from 'react-select'

export function displayInput(form: any, element: any, valueFormulaire: any) {
    if (form[element] === 'string' || form[element] === 'datetime' || form[element] === 'date') {
        return (<div className="block" key={element}>
            <label className="vtmn-text-input_label vtmn-capitalize" style={{ paddingLeft: '5%' }}
                htmlFor="overview-input-1">{element.replaceAll('_', ' ')}</label>
            <div className="vtmn-text-input_container" style={{ width: '100%', }}>
                <input
                    type={form[element] === 'datetime' ? 'datetime-local' : form[element]}
                    className="vtmn-text-input"
                    id={element}
                    name={element}
                    placeholder={element}
                    aria-describedby="overview-input-helper-1"
                    defaultValue={valueFormulaire[element] ?? undefined}
                    style={{ width: '90%', margin: 'auto' }}
                />
            </div>
        </div>)
    } else if (form[element] && form[element].type === 'multiple') {
        return (<div className="block" key={element}>
            <label className="vtmn-text-input_label vtmn-capitalize" style={{ paddingLeft: '5%' }}
                htmlFor="overview-input-1">{element.replaceAll('_', ' ')}</label>
            <div className="vtmn-text-input_container" style={{ width: '95%', paddingLeft: '5%' }}>
                <Select
                    isMulti
                    id={element}
                    name={element}
                    className="select-form"
                    options={form[element].value.sort().map((v: string) => { return { value: v, label: v } })}
                    defaultValue={valueFormulaire &&  valueFormulaire[element] ? valueFormulaire[element].map((v: string) => { return { value: v, label: v } }) : undefined }
                />
            </div>
        </div>)
    } else if (form[element] && form[element].type === 'select') {
        return (<div className="block" key={element}>
            <div className="vtmn-select_container" style={{ width: '95%', paddingLeft: '5%' }}>
                <label className="vtmn-text-input_label vtmn-capitalize" htmlFor={element}>{element.replaceAll('_', ' ')}</label>
                <select
                    id={element}
                    name={element}
                    className="vtmn-text-input"
                >
                    <option value="" disabled selected>Select</option>
                    {form[element].value.map((v: string) => { return <option selected={valueFormulaire[element] === v} value={v}>{v} </option> })}
                </select>
            </div>
        </div>)
    }
}